<template>
  <div>
    <div id="preloader">
      <div id="status">
        <div class="spinner-chase">
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
          <div class="chase-dot"></div>
        </div>
      </div>
    </div>
    <div id="layout-wrapper">
      <HorizontalTopbarInside />
      <SideBar :is-condensed="isMenuCondensed" :type="leftSidebarType" :width="layoutWidth" />
      <div class="main-content">
        <div class="page-content">
          <!-- Start Content-->
          <div class="container-fluid">
            <slot />
          </div>
        </div>
        <Footer />
        <h2 class="h-text">{{$t('message.Test_candidates')}}</h2>
        <b-row class="mx-4 px-3">
          <b-col md="6">
            <div class="select w-75">
              <label>{{$t('message.Province')}}</label>
              <b-form-select
                  v-model="form.region_id"
                  :options="regions"
                  text-field="nameuz"
                  value-field="id"
                  @input="fetchRayons"
                  class="form-select d-flex"
                  aria-label="Default select example"></b-form-select>
              <label class="mt-2">{{$t('message.Region')}}</label>
              <b-form-select
                  v-model="form.rayon_id"
                  :options="rayons"
                  text-field="nameuz"
                  value-field="id"
                  @input="fetchSchools"
                  class="form-select d-flex"
                  aria-label="Default select example"></b-form-select>
              <label class="mt-2">{{$t('message.Schools')}}</label>
              <b-form-select
                  v-model="form.school_id"
                  :options="schools"
                  text-field="organizationfullname"
                  value-field="organizationid"
                  class="form-select d-flex"
                  aria-label="Default select example"></b-form-select>
            </div>
          </b-col>
          <b-col md="6">
            <div class="select w-75">
              <label>{{$t('message.Position_level')}}</label>
              <b-form-select
                  v-model="form.position_level_id"
                  :options="position_level"
                  text-field="name_uz"
                  value-field="id"
                  class="form-select d-flex"
                  aria-label="Default select example"></b-form-select>
              <label class="mt-2">{{$t('message.Positions')}}</label>
              <b-form-select
                  v-model="form.position_id"
                  :options="positions"
                  text-field="name_uz"
                  value-field="id"
                  class="form-select d-flex"
                  aria-label="Default select example"></b-form-select>
              <div class="d-inline-flex mt-4">
                <b-button variant="warning" size="lg" @click="fetchCandidates" style="margin-right: 20px; width: 150px">
                  <div style="color: #185d89">
                    {{$t('message.Search')}}
                  </div>
                </b-button>
                <b-button size="lg" class="me-2" @click="resetFilter" style="width: 150px; background-color: #185d89" >
                  {{$t('message.Clear')}}
                </b-button>
              </div>
            </div>
          </b-col>
        </b-row>
        <div>
          <b-card
              class="mt-4 d-flex mx-4 ms-5"
              style="width: 90%; margin: 0 auto;"
           >
            <b-table
                responsive
                striped
                hover
                :items="candidates"
                :fields="fields">
              <template #cell(created_at)="{item}">
                {{item.created_at | formatDate}}
              </template>
              <template #cell(status)="data">
                <i class="bx bx-list-ol  font-size-24"
                @click="handlePush"></i>
              </template>
              <template #cell(action)="{item}">
                <b-button
                    variant="primary"
                    style="margin-left: 10px;background-color: #185d89"
                    size="sm"
                    @click="goToRoute(item)"
                ><i class='bx bx-show'></i>
                </b-button>
              </template>
            </b-table>
            <div class="mt-4 d-flex justify-content-end">
              <b-pagination
                  class="pagination"
                  v-model="pagination.page"
                  :total-rows="total"
                  :per-page="pagination.pageSize"
                  @page-click="fetchCandidates"
              ></b-pagination>
            </div>
          </b-card>
        </div>
      </div>
    </div>

    <b-modal v-model="applicationModal" hide-footer size="lg">
      <b-row v-if="activeApplication">
        <b-col md="6">
          <div class="w-100 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.FullName')}}</h5>
            <p>{{activeApplication.fio}}</p>
          </div>
          <div class="w-100 mt-2 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.Category')}}</h5>
            <p>{{activeApplication.category.name}}</p>
          </div>
          <div class="w-100 mt-2 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.Education')}}</h5>
            <p>{{activeApplication.education.name}}</p>
          </div>
          <div class="w-100 mt-2 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.Experience')}}</h5>
            <p>{{activeApplication.experience.name}}</p>
          </div>
          <div class="w-100 mt-2 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.Lidership_experience')}}</h5>
            <p>{{activeApplication.lidership_experience.name}}</p>
          </div>
          <div class="w-100 mt-2 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.Mobile_number')}}</h5>
            <p>{{activeApplication.mobile}}</p>
          </div>
          <div class="w-100 mt-2 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.Lidership_experience')}}</h5>
            <p>{{activeApplication.lidership_experience.name}}</p>
          </div>
          <div class="w-100 mt-2 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.Address')}}</h5>
            <p>{{activeApplication.address}}</p>
          </div>
        </b-col>
        <b-col md="6">
          <div class="w-100 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.Objective')}}</h5>
            <a :href="$backendHost+activeApplication.objective" target="_blank" class="btn btn-outline-warning">
              <i class="bx bx-download"></i>
            </a>
          </div>
          <div class="w-100 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.Government_reward')}}</h5>
            <a :href="$backendHost+activeApplication.government_reward" target="_blank" class="btn btn-outline-warning">
              <i class="bx bx-download"></i>
            </a>
          </div>
          <div class="w-100 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.Network_reward')}}</h5>
            <a :href="$backendHost+activeApplication.network_reward" target="_blank" class="btn btn-outline-warning">
              <i class="bx bx-download"></i>
            </a>
          </div>
          <div class="w-100 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.Other_reward')}}</h5>
            <a :href="$backendHost+activeApplication.other_reward" target="_blank" class="btn btn-outline-warning">
              <i class="bx bx-download"></i>
            </a>
          </div>
          <div class="w-100 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.Teacher_competition')}}</h5>
            <a :href="$backendHost+activeApplication.teacher_competition" target="_blank" class="btn btn-outline-warning">
              <i class="bx bx-download"></i>
            </a>
          </div>
          <div class="w-100 mt-2 border-bottom">
            <h5 class="font-weight-semibold">{{$t('message.PINFL')}}</h5>
            <p>{{activeApplication.pinfl}}</p>
          </div>
        </b-col>
      </b-row>
    </b-modal>
  </div>
</template>

<script>
// import Layout from "../../../../../../layouts/main";
import SideBar from "../../../../../../components/side-bar";
import router from "@/router";
import { layoutComputed } from "@/state/helpers";
import {getCandidates} from "../../../../../../api/candidates";
import {getRayons, getRegions} from "../../../../../../api/regions";
import {getSchools} from "../../../../../../api/schools";
import {getPositionLevels, getPositions} from "../../../../../../api/directories";
import HorizontalTopbarInside from "../../../../../../components/horizontal-topbar-inside";
import moment from "moment";


export default {
  name: "TestCandidates",
  components: {
    HorizontalTopbarInside, SideBar
  },
  filters:{
    formatDate(val) {
      return moment(val).format('DD-YY-YYYY')
    }
  },
  data() {
    return {
      isMenuCondensed: false,
      activeApplication: null,
      applicationModal: false,
      rows: 10,
      perPage: 1,
      currentPage: 5,
      pagination:{
        page: 1,
        pageSize: 20,
        results: false,
      },
      options: [],
      total:1,
      form:{
        region_id : null,
        rayon_id : null,
        school_id : null,
        position_level_id : null,
        position_id : null,
      },
      fields: [
        {
          key:'id',
          label: this.$t("message.Id")
        },
        {
          key:'fio',
          label: this.$t('message.FullName'),
        },
        {
          key:'mobile',
          label: this.$t('message.Mobile_number')
        },
        {
          key:'vacancy.position_level.name',
          label: this.$t("message.Position_level")
        },
        {
          key:'vacancy.position.name',
          label: this.$t('message.Positions')
        },
        {
          key:'region.nameuz',
          label: this.$t('message.Region')
        },
        {
          key:'rayon.nameuz',
          label: this.$t('message.Rayon')
        },
        {
          key:'vacancy.school.organizationfullname',
          label: this.$t('message.Schools')
        },
        {
          key:'created_at',
          label: this.$t('message.CreatedAt')
        },
        {
          key:'action',
          label: this.$t('message.Action')
        },
      ],
      candidates: [],
      regions:[],
      rayons:[],
      schools:[],
      position_level:[],
      positions:[],
    };
  },
  computed: {
    ...layoutComputed,
  },
  created()  {
    if(this.$route.name === 'test-result') {
      this.pagination.results = true;
    }
    document.body.removeAttribute("data-layout", "horizontal");
    document.body.removeAttribute("data-topbar", "dark");
    document.body.removeAttribute("data-layout-size", "boxed");
    document.body.classList.remove("auth-body-bg");
    this.fetchRegions()
    this.fetchPositionLevel()
    this.fetchPositions()
    this.fetchCandidates();
  },
  methods: {
    fetchCandidates(){
      getCandidates({...this.form,...this.pagination}).then(response => {
        this.candidates = response.data.data.data
      })
    },
    fetchRegions(){
      getRegions().then(response => {
        this.regions = response.data.data
      })
    },
    fetchRayons(){
      this.form.rayon_id = null
      getRayons(this.form.region_id).then(response => {
        this.rayons = response.data.data
      })
    },
    fetchSchools(){
      getSchools({oblastid: this.form.region_id , regionid: this.form.rayon_id}).then(response => {
        this.schools = response.data.data
      })
    },
    fetchPositionLevel(){
      getPositionLevels().then(response => {
        this.position_level = response.data.data
      })
    },
    fetchPositions(){
      getPositions().then(response => {
        this.positions = response.data.data
      })
    },
    resetFilter() {
      this.form.rayon_id = null;
      this.form.position_level_id = null;
      this.form.position_id = null
      this.form.region_id = null;
      this.form.school_id = null;
      this.fetchCandidates()
    },
    goToRoute(data) {
      if(this.$route.name === 'test-result') {
        this.$router.push({name:"test-result-action", params: {id:data.id}})
      }
      else {
        this.activeApplication = data;
        this.applicationModal = true;
      }
    },
    toggleMenu() {
      document.body.classList.toggle("sidebar-enable");

      if (window.screen.width >= 992) {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
          document.body.classList.remove("vertical-collpsed");
        });
        document.body.classList.toggle("vertical-collpsed");
      } else {
        // eslint-disable-next-line no-unused-vars
        router.afterEach((routeTo, routeFrom) => {
          document.body.classList.remove("sidebar-enable");
        });
        document.body.classList.remove("vertical-collpsed");
      }
      this.isMenuCondensed = !this.isMenuCondensed;
    },
    handlePush(){
      this.$router.push({name: 'test-result'})

    },
    toggleRightSidebar() {
      document.body.classList.toggle("right-bar-enabled");
    },
    hideRightSidebar() {
      document.body.classList.remove("right-bar-enabled");
    },
  },
  mounted() {
    if (this.loader === true) {
      document.getElementById("preloader").style.display = "block";
      document.getElementById("status").style.display = "block";

      setTimeout(function () {
        document.getElementById("preloader").style.display = "none";
        document.getElementById("status").style.display = "none";
      }, 2500);
    } else {
      document.getElementById("preloader").style.display = "none";
      document.getElementById("status").style.display = "none";
    }
  },
  watch: {
    '$route.name':{
      handler(val) {
        // eslint-disable-next-line no-console
        console.log(val);
        location.reload()
      }
    }
  }
}
</script>

<style scoped>
h2{
  margin-left: 70px;
  margin-bottom: 50px;
  color: #4d63cf;
}
.has-search .form-control {
  padding-left: 28px;
}
.has-search .form-control-feedback {
  position: absolute;
  z-index: 2;
  display: block;
  width: 2.375rem;
  height: 2.375rem;
  line-height: 2.375rem;
  text-align: center;
  pointer-events: none;
  color: #aaa;
}
.form-group{
  margin-left: 20px;
}
.form-select{
  margin-left: 5px;
}
.pagination{
  margin-left: 400px;
}
.bx{
  cursor: pointer;
}

</style>



